// extracted by mini-css-extract-plugin
export default {"wrapper":"E38Br","title":"bUeen"};